/** @jsx jsx */
import { jsx } from 'theme-ui'
import ListingCardSimple from '~/components/Listing/Card/Simple'
import { getAvailableMerchSkus } from '~/utils/merch'

const MerchCardSimple = ({ merch, showPrice = true }) => {
  const { mainImage, name, slug } = merch
  const availableSkus = getAvailableMerchSkus(merch)
  const { price } = availableSkus[0]

  return (
    <ListingCardSimple
      mainImage={mainImage}
      name={name}
      price={showPrice && price}
      slug={slug}
    />
  )
}

export default MerchCardSimple
